module.exports = __webpack_public_path__ + "static/media/icomoon.bf3fa7aa.ttf";